import { AlternativesCTASection, CTASectionProps } from "@components/alternatives/AlternativesCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import ProblemSectionCard, { ProblemSection } from "@components/solution/problemSectionCard";
import { BlueCardCTASection, GreyCardCTASection } from "@components/solution/solutionCTASection";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "GALLABOX FOR CUSTOMER SUPPORT",
    title: "Exceptional customer experience at scale ",
    description: "Set up WhatsApp chatbots to improve customer satisfaction scores by up to 80% — impacting retention and boosting repeat business.",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/hero-section.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Automated AI chatbots and support flows",
    subtitle2: "Gallabox helps enterprises streamline customer interactions and tackle support efficiently",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/automated-ai-chatbot.png",
    featureInfoList: [
        "AI chatbots for customer queries and service tickets",
        "Custom workflows help you humanize your customer interactions",
        "Effective agent handoff ensures the right agent takes over customer conversations when needed.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Shared team inboxes",
    subtitle2: "Use Gallabox’s shared team inbox to make sure all your support agents are on the same page",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/shared-team-inbox.png",
    featureInfoList: [
        "Handle large volumes of queries and tickets",
        "Single dashboard to display conversations across the organization in one place",
        "Easy agent handoffs and interventions",
    ],
};
const featureInfo3: FeatureInfo = {
    mainTitle: "Gen AI chat support",
    subtitle2: "Boost efficiency with AI-powered quick replies, issue escalations, and feedback collection",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/ai-chatbot-support.png",
    featureInfoList: ["Intelligent suggestions and pre-set response templates", "AI-driven issue resolutions", "Effective agent intervention for complex interactions."],
};
const featureInfo4: FeatureInfo = {
    mainTitle: "Advanced feedback surveys",
    subtitle2: "Collect customer feedback and ensure better after-service customer satisfaction.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/feedback-support.png",
    featureInfoList: ["Automated feedback collection templates", "Resolution follow-ups and auto-reponses", "Drive additional upsell opportunities"],
};

const ProblemSectionData: ProblemSection = {
    maintitle: "Struggling to meet rising customer expectations?",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/customer-supporter.svg",
            title: "Overwhelmed customer support teams",
            description: "A lack of round-the-clock availability across time zones can lead to more customers walking out the door.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/language.svg",
            title: "Multilingual communication in a globalized world",
            description: "Lacking multilingual support can stop companies from creating inroads towards customer loyalty and brand loyalty.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
            title: "Difficulty managing inquiry surges",
            description: "Traditional appointment booking can be time-intensive when dealing with sudden spikes in customer queries.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/gui-question.svg",
            title: "Absence of two-way communication",
            description: "Real-time updates over phone, email, text, or WhatsApp is important but challenging if you’re doing it manually.",
        },
    ],
};

const blueCardCTAContent: CTASectionProps = {
    content: "Get your own customer service WhatsApp chatbots",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-cta.png",
    imgAlt: "wa-gallabox",
    btnText: "Get a free trial today",
};

const greyCardCTAContent: CTASectionProps = {
    content: "Dubai Housekeeping increased their CSAT by 47% with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/support/dubai-housekeeping.png",
    imgAlt: "wa-gallabox",
    btnText: "Read the story",
};

const supportProductData: Array<Product> = [
    {
        title: "Enhance personalization",
        description: "Deliver contextual, customer-specific responses by integrating WhatsApp with your CRM and support tools.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
        externalLink: "",
    },
    {
        title: "Streamline ticket management",
        description: "Automatically categorize, prioritize, and assign tickets for faster issue resolution and workflow efficiency.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/ticket.png",
        externalLink: "",
    },
    {
        title: "Improve first-contact resolution",
        description: "Minimize follow-ups with AI-driven responses that solve customer issues in a single interaction.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/bot.svg",
        externalLink: "",
    },
    {
        title: "Seamless handoff to live agents",
        description: "Transition complex queries from chatbots to human agents smoothly, ensuring a hassle-free experience.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/hand-shake.svg",
        externalLink: "",
    },
    {
        title: "Engage with rich media",
        description: "Use images, videos, voice notes, and interactive buttons to offer a more engaging support experience.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/profile-image.svg",
        externalLink: "",
    },
    {
        title: "Track and optimize performance",
        description: "Gain real-time insights into response times, resolution rates, and CSAT to fine-tune your support strategy.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
        externalLink: "",
    },
    {
        title: "Simplify issue resolution",
        description: "Manage customer interactions more effectively, handle queries, and collect feedback using advanced chatbots",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/checked.svg",
        externalLink: "",
    },
    {
        title: "Integrate with other business tools",
        description: "Use over 30+ powerful integrations to create a seamless workflow for managing customers and service tickets",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
        externalLink: "",
    },
];

const sales: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Business Solution for Customer Support | Gallabox"}
            description={"Improve your customer support with Gallabox’s WhatsApp Business solution—automate conversations, reduce response times, and improve service quality."}
            canonical="https://gallabox.com/solutions/customer-support"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/solution/support/solution-support-og.png" }}
            schema={{
                heroOrOgImageAlt: "solutions-customer-supports-image",
                heroOrOgImageDescription: "Exceptional customer experience at scale ",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/solution/support/hero-section.png",
                softwareFeatureName: "customer-support",
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>
            <ProblemSectionCard problemSection={ProblemSectionData} />
            <section className="mx-5">
                <BlueCardCTASection ctaContent={blueCardCTAContent} />
            </section>

            <h5 className={`${container_classname} md:text-7xl text-5xl mt-20`} style={{ fontFamily: "Degular Display" }}>
                Why support teams trust Gallabox
            </h5>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />

            <div className="mx-5">
                <AlternativesCTASection
                    ctaContent={{
                        content: "End-to-end customer support through WhatsApp",
                        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt/wa-gallabox.png",
                        imgAlt: "sales-automations",
                        btnText: "Get a free trial today",
                    }}
                />
            </div>

            <ProductSection productCardData={supportProductData} title="How Gallabox transforms customer support teams" />
            <div className={`${container_classname} my-20`}>
                <h5 className="text-6xl mb-10">Customer story</h5>
            </div>

            <section className="mx-5">
                <GreyCardCTASection ctaContent={greyCardCTAContent} />
            </section>
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default sales;
